import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import abbreviateNumber from 'core/utils/abbreviateNumber';
import { plural } from 'core/utils/stringUtils';
import { ThumbsUpIcon, ThumbVoteBtn, VoteCount, BounceWrapper } from './votingStyles';

class ThumbVoting extends PureComponent {
	handleVote(upVote = true) {
		this.props.onVote(upVote);
	}

	render() {
		const { activeVote, upVotes, downVotes } = this.props;
		const hasUpVote = activeVote === "up";
		const hasDownVote = activeVote === "down";
		let voteCount = upVotes - downVotes;
		if (hasUpVote) voteCount += 1;
		if (hasDownVote) voteCount -= 1;
		return (
			<ThumbVoteBtn onClick={() => this.handleVote()}>
				<BounceWrapper up bounce={hasUpVote}>
					<ThumbsUpIcon />
				</BounceWrapper>
				<VoteCount>
					{voteCount === 0 ? 'Vote for this' :
						`${abbreviateNumber(voteCount)} ${plural('Vote', voteCount)}`
					}
				</VoteCount>
			</ThumbVoteBtn>
		);
	}
}

ThumbVoting.propTypes = {
	activeVote: PropTypes.oneOf(["up", "down"]),
	upVotes: PropTypes.number,
	downVotes: PropTypes.number,
	onVote: PropTypes.func,
	noun: PropTypes.string,
};

ThumbVoting.defaultProps = {
	activeVote: null,
	upVotes: 0,
	downVotes: 0,
	onVote: () => null,
	noun: "Answer",
};

export default ThumbVoting;
